import { PublicTemplateIframe } from './PublicTemplateIframe';

export const FullScreenPublicTemplate = () => {
    return (
        <div className="template-preview__full-screen-preview">
            <PublicTemplateIframe />
        </div>
    );
};
